import { render, staticRenderFns } from "./DeliveryInstructionsField.vue?vue&type=template&id=119aee27&"
import script from "./DeliveryInstructionsField.vue?vue&type=script&lang=js&"
export * from "./DeliveryInstructionsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports